import 'bootstrap/js/src/carousel'
import { DEFAULT_PHONES } from 'core/services/getPhone'
import getById from 'utils/DOM/getById'
import { enableMultiCarrierPlans } from 'utils/experiments'
import removeElements from 'utils/DOM/removeElements'

let $overlay = null

async function init(hcStorage) {
  if (window.matchMedia('(min-width: 992px)').matches) {
    $overlay = $('.FadedOverlay')
    $('body').off('click.formOverlay')

    $overlay.off('click.hideOverlay').on('click.hideOverlay', () => {
      $overlay.removeClass('FadedOverlay--shown')
    })
  }

  const phoneNumberFormLink = getById('phone-number-census-form')
  const invocaPhone = hcStorage.invoca_phone
  if (phoneNumberFormLink && invocaPhone) {
    phoneNumberFormLink.innerText =
      invocaPhone.promo_number_formatted_dash ||
      DEFAULT_PHONES.enroll.promo_number_formatted_dash
    const promoNumber = invocaPhone.promo_number || DEFAULT_PHONES.enroll.promo_number
    phoneNumberFormLink.setAttribute('href', `tel:${promoNumber}`)
  }

  if (!enableMultiCarrierPlans()) {
    removeElements('.d-hidden-php-fn')
  }
}

export default init
